module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.444 10.357l8.173 8.204a.8.8 0 0 1-.56 1.36.792.792 0 0 1-.563-.232l-8.173-8.204-8.172 8.204a.792.792 0 0 1-1.122 0 .8.8 0 0 1 0-1.126l8.172-8.203-8.172-8.203a.8.8 0 0 1 0-1.128.79.79 0 0 1 1.122 0L10.32 9.23l8.174-8.204a.792.792 0 0 1 1.123 0 .8.8 0 0 1 0 1.128l-8.173 8.203z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/shared/InlineEditor/images/cross.svg
// module id = 8B31
// module chunks = 89